import { render, staticRenderFns } from "./ordinary_program.vue?vue&type=template&id=2b485637&scoped=true&"
import script from "./ordinary_program.vue?vue&type=script&lang=js&"
export * from "./ordinary_program.vue?vue&type=script&lang=js&"
import style0 from "./ordinary_program.vue?vue&type=style&index=0&id=2b485637&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b485637",
  null
  
)

export default component.exports